import { create } from "zustand";
import { persist } from "zustand/middleware";

import {
  COUNTDOWN_OPTIONS,
  DEFAULT_EXAM_QUESTION_COUNT,
  DEFAULT_FLASHCARD_SESSION_SIZE,
  type ExamQuestionCountOption,
  type FlashcardSessionSize,
} from "@/lib/constant";

type SettingsState = {
  isMuted: boolean;
  countdownSeconds: number;
  examQuestionCount: ExamQuestionCountOption;
  flashcardSessionSize: FlashcardSessionSize;
  toggleMute: () => void;
  setIsMuted: (muted: boolean) => void;
  setCountdownSeconds: (seconds: number) => void;
  setExamQuestionCount: (count: ExamQuestionCountOption) => void;
  setFlashcardSessionSize: (size: FlashcardSessionSize) => void;
};

export const useSettingsStore = create<SettingsState>()(
  persist(
    set => ({
      isMuted: false,
      countdownSeconds: COUNTDOWN_OPTIONS[1],
      examQuestionCount: DEFAULT_EXAM_QUESTION_COUNT,
      flashcardSessionSize: DEFAULT_FLASHCARD_SESSION_SIZE,
      toggleMute: () => set(state => ({ isMuted: !state.isMuted })),
      setIsMuted: (isMuted: boolean) => set({ isMuted }),
      setCountdownSeconds: (countdownSeconds: number) => set({ countdownSeconds }),
      setExamQuestionCount: (examQuestionCount: ExamQuestionCountOption) => set({ examQuestionCount }),
      setFlashcardSessionSize: (flashcardSessionSize: FlashcardSessionSize) => set({ flashcardSessionSize }),
    }),
    { name: "tobo:settings" },
  ),
);
